import { findTypeByCode } from '../filterArrays';

export default ({ form = [], myRatings, raceRecords = [] }) => {
    if (!myRatings) {
        return raceRecords;
    }

    const hasRating = id => Boolean(myRatings[id]);
    const findRaceById = id => form.find(({ raceInstanceUid: uid }) => Number(id) === uid);

    const preparedData = Object.keys(myRatings)
        .filter(hasRating)
        .map((id) => {
            const { raceTypeCode } = findRaceById(id);
            return raceTypeCode
            ? {
                type: findTypeByCode(raceTypeCode),
                rating: myRatings[id],
            }
            : {};
        })
        .reduce((acc, { type, rating }) => ({
            ...acc,
            [type]: Math.max(acc[type] || 0, rating),
        }), {});

    return raceRecords.map(row => ({
        ...row,
        myRating: preparedData[row.raceType],
    }));
};



// WEBPACK FOOTER //
// ./src/js/horse/form/raceRecords/mergeWithMR.js